import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsGuard {
  constructor(
    private userDataService: UserDataService,
    private permissionsService: PermissionsService,
    private router: Router,
  ) {}

  isGlobalSettingsEnabled = false;

  canActivate(): Observable<boolean | UrlTree> {
    return this.userDataService.getCompany$().pipe(
      switchMap((company) => {
        if (!company) {
          return of(false);
        }

        const hasMspOrRps =
          company.serviceAddons.includes('managed-services') || company.serviceAddons.includes('repair-services');
        if (!hasMspOrRps) {
          return of(false);
        }

        return this.userDataService.getUser().then((user) => {
          if (!user) {
            return this.router.createUrlTree(['/secured/home']);
          }

          const canAccessGlobalSettings = this.permissionsService.hasCompanyAdminPermissions();

          return canAccessGlobalSettings || this.router.createUrlTree(['/secured/home']);
        });
      }),
      catchError(() => of(this.router.createUrlTree(['/secured//home']))),
    );
  }
}
